<template>
	<view class="pingjia-wrap">
		
		<u-popup v-model="popupShow"  mode="center" width="90%" height="40%" closeable>
		  <view>
			  <view class="haopingImg-box">
			  	  <image class="pingjiaImg" src="../../static/image/pingjia.png" mode="aspectFill"></image>
			  </view>
			  <view class="rate-box">
			  	<u-rate :count="count" v-model="level"></u-rate>
			  </view>
			  <view class="btn-box">
				  <u-button
				    type="info" 
					class="cacelBtn"
					@click="cancleBtn">取消</u-button>
				  <u-button 
				    type="success" 
					class="submitBtn"
					@click="submitPingjiaBtn">提交</u-button>
			  </view>
		  </view>
		</u-popup>
	</view>
</template>

<script>
	export default {
		name:"pingjia",
		inject:['orderId'],
		data() {
			return {
				popupShow: false,
				count:5,
				level:5
			};
		},
		onLoad() {
		},
		mounted() {
			console.log('orderId====',this.orderId.orderId)
		},
		methods: {
			pingjiaInit() {
				this.popupShow = true
			},
			submitPingjiaBtn() {
				let params = {
					level:this.level,
					orderId:this.orderId.orderId
				}
				this.$u.api.remark(params).then(res => {
					if(res.code == 200) {
						this.$u.toast(res.message)
						this.$emit('refeshOrderDetail')
						this.popupShow = false
					}else{
						
					}
				})
			},
			cancleBtn() {
				this.popupShow = false
			}
		}
	}
</script>

<style lang="scss" scoped>
	.pingjia-wrap{
		/deep/ .u-btn--default{
			border:none;
			color: #1F9F4C;
			background-color: transparent;
		}
	}
	
	.pingjia-wrap{
		width: 90%;
		margin: 0 auto;
	}
	.haopingImg-box{
		width: 100%;
		display: flex;
		justify-content: center;
		.pingjiaImg{
			  width: 240rpx;
			  height: 240rpx;
			  margin-top: 80rpx;
		}
	}
    .rate-box{
		width: 100%;
		display: flex;
		justify-content: center;
		margin-top: 20rpx;
	}
	.btn-box{
		display: flex;
		margin-top: 40rpx;
		justify-content: center;
		.cacelBtn{
			width: 260rpx;
			height: 72rpx;
			background-color: #CCCCCC;
			color: #FFFFFF;
			margin-right: 20rpx;
		}
		.submitBtn{
			width: 260rpx;
			height: 72rpx;
			background-color: #CCCCCC;
			color: #1F9F4C;
		}
	}
	
</style>
